<template lang="">
  <PageComponents>
    <template>
    <div>

      
      <div class="container">
        <div class="row voffset-lg align-items-start mb-lg-0 mt-lg-0">
          <div class="col-lg-12">
            <h3 class="text-center text-lg-start tc-4241 h3-2-style mb-lg-3 h3-bloc-1-style1">企业内部通讯-小马APP<br></h3>
            <p class="text-center text-lg-start p-8-style mb-lg-4 tc-2340">
              由深圳数马电子技术有限公司团队研发出一款供深圳数马电子技术有限公司企业内部员工使用的专用聊天通讯工具。让企业员工更高效的完成日常的工作沟通、业务处理，使得办公的方式简洁、方便、高效。<br></p>
            <div class="row mb-lg-0 align-items-start mt-lg-5">
              <div class="col offset-lg-0 order-lg-0 me-lg-2">
                <h3 class="mb-4 tc-2340 h5-style mb-lg-2"><span
                    class="icon-4241 far fa-comments icon-sm"></span>&nbsp;支持单聊、群聊</h3>
                <div class="row">
                  <div class="col pe-lg-1">
                    <picture>
                      <img
                        :src="png11" data-src="img/1-1.png" class="img-fluid  d-block lazyload"
                        alt="1 1" width="175" height="364">
                    </picture>
                  </div>
                  <div class="col ps-lg-1">
                    <picture>
                      
                      <img
                        :src="png12" data-src="img/1-1.png" class="img-fluid  d-block lazyload"
                        alt="1 1" width="175" height="364">
                    </picture>
                  </div>
                </div>
              </div>
              <div class="col offset-lg-0 order-lg-0 me-lg-2">
                <h3 class="mb-4 tc-2340 h5-style mb-lg-2"><span
                    class="icon-4241 icon-sm fa fa-sitemap"></span>&nbsp;支持工作审批处理</h3>
                <div class="row">
                  <div class="col pe-lg-1">
                    <picture>
                      
                      <img
                        :src="png7" data-src="img/1-1.png" class="img-fluid  d-block lazyload"
                        alt="1 1" width="175" height="364">
                    </picture>
                  </div>
                  <div class="col ps-lg-1">
                    <picture>
                      
                      <img
                        :src="png72" data-src="img/1-1.png" class="img-fluid  d-block lazyload"
                        alt="1 1" width="175" height="364">
                    </picture>
                  </div>
                </div>
              </div>
              <div class="col offset-lg-0 order-lg-0">
                <h3 class="mb-4 tc-2340 h5-style mb-lg-2"><span
                    class="icon-4241 icon-sm far fa-calendar-alt"></span>&nbsp;支持预约日程、添加代办</h3>
                <div class="row">
                  <div class="col pe-lg-1">
                    <picture>
                      
                      <img
                        :src="png31" data-src="img/1-1.png" class="img-fluid  d-block lazyload"
                        alt="1 1" width="175" height="364">
                    </picture>
                  </div>
                  <div class="col ps-lg-1">
                    <picture>
                      
                      <img
                        :src="png32" data-src="img/1-.png" class="img-fluid  d-block lazyload"
                        alt="1 1" width="175" height="364">
                    </picture>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-lg-0 align-items-start mt-lg-5">
              <div class="col offset-lg-0 order-lg-0 me-lg-2">
                <h3 class="mb-4 tc-2340 h5-style mb-lg-2"><span
                    class="icon-4241 icon-sm far fa-handshake"></span>&nbsp;支持公司部门员工服务小助手</h3>
                <div class="row">
                  <div class="col pe-lg-1">
                    <picture>
                      
                      <img
                        :src="png4" data-src="img/1-1.png" class="img-fluid  d-block lazyload"
                        alt="1 1" width="175" height="364">
                    </picture>
                  </div>
                  <div class="col ps-lg-1">
                    <picture>
                      
                      <img
                        :src="png42" data-src="img/1-1.png" class="img-fluid  d-block lazyload"
                        alt="1 1" width="175" height="364">
                    </picture>
                  </div>
                </div>
              </div>
              <div class="col offset-lg-0 order-lg-0 me-lg-2">
                <h3 class="mb-4 tc-2340 h5-style mb-lg-2"><span
                    class="icon-4241 icon-sm far fa-edit"></span>&nbsp;支持项目日常进度汇报</h3>
                <div class="row">
                  <div class="col pe-lg-1">
                    <picture>
                      
                      <img
                        :src="png5" data-src="img/1-1.png" class="img-fluid  d-block lazyload"
                        alt="1 1" width="175" height="364">
                    </picture>
                  </div>
                  <div class="col ps-lg-1">
                    <picture>
                      
                      <img
                        :src="png52" data-src="img/1-1.png" class="img-fluid  d-block lazyload"
                        alt="1 1" width="175" height="364">
                    </picture>
                  </div>
                </div>
              </div>
              <div class="col offset-lg-0 order-lg-0">
                <h3 class="mb-4 tc-2340 h5-style mb-lg-2"><span
                    class="icon-4241 icon-sm fa fa-bullhorn"></span>&nbsp;支持发布公司全员公告通知</h3>
                <div class="row">
                  <div class="col pe-lg-1">
                    <picture>
                      
                      <img
                        :src="png8" data-src="img/1-1.png" class="img-fluid  d-block lazyload"
                        alt="1 1" width="175" height="364">
                    </picture>
                  </div>
                  <div class="col ps-lg-1">
                    <picture>
                      
                      <img
                        :src="png82" data-src="img/1-1.png" class="img-fluid  d-block lazyload"
                        alt="1 1" width="175" height="364">
                    </picture>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-lg-3">
              <div class="col mb-lg-5">
                <h3 class="mb-4 tc-4241 mt-lg-5"><span class="fa fa-arrow-circle-down"></span>&nbsp;软件下载</h3>
                <div class="row">
                  <div class="col"><a href="http://dl.xhorse.net.cn/product/common/app/xchat/android/release/XhorseIM.apk" target="_blank" class="btn btn-lg btn-c-978 btn-5-style"><span
                        class="icon-spacer icon-3035 fab fa-android"></span>&nbsp;Android<br></a></div>
                  <div class="col ios-btn-container"><a target="_blank" class="btn btn-lg btn-c-978 btn-5-style"><span
                        class="icon-spacer icon-3035 fab fa-apple"></span>&nbsp;iOS</a>
                          <div class="qr-container">
                            <div class="container">
                              <img :src="qrcode">
                              <div style="text-align:center">
                                请使用IOS浏览器扫码下载
                              </div>
                            </div>

                          </div>
                        </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="alert bgc-4241 alert-warning" role="alert"><a href="#"
                class="btn btn-d btn-lg btn-style-none float-end" data-bs-dismiss="alert" aria-label="Close"></a>
              <p class="mb-0">If you have any advice or need any help, we will try our best to serve you. &nbsp; &nbsp;-
                Customer Service: 400-777-8776 &nbsp; &nbsp; - Email: support@xhorse.com<br></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </template>
  </PageComponents>
</template>
<script>
import PageComponents from "@/components/page-components";
import png11 from "@/assets/css/img/1-1.png";
import png12 from "@/assets/css/img/1-2.png";
import png31 from "@/assets/css/img/3-1.png";
import png32 from "@/assets/css/img/3-2.png";
import png4 from "@/assets/css/img/4.png";
import png42 from "@/assets/css/img/4-2.png";
import png5 from "@/assets/css/img/5.png";
import png52 from "@/assets/css/img/5-2.png";
import png7 from "@/assets/css/img/7.png";
import png72 from "@/assets/css/img/7-2.png";
import png8 from "@/assets/css/img/8.png";
import png82 from "@/assets/css/img/8-2.png";
import qrcode from "@/assets/css/img/qrcode.png";
export default {
  components: {
    PageComponents
  },
  data: () => ({
    png11,
    png12,
    png31,
    png32,
    png4,
    png42,
    png5,
    png52,
    png7,
    png72,
    png8,
    qrcode,
    png82,
    activeIndex: {
      side: [],
      top: []
    }
  }),
  beforeRouteLeave(to, from, next) {
    //console.log("template[about]", to, from)
    const _this = this;
    var data = {
      side: _this.activeIndex.side,
      top: _this.activeIndex.top
    };

    if (
      to.params.hasOwnProperty("activeTop") &&
      to.params.hasOwnProperty("activeSide")
    ) {
      data.side = to.params.activeSide;
      data.top = to.params.activeTop;
    }

    _this.$store.commit("setActivePath", {
      type: "all",
      val: data
    });
    window.removeEventListener("scroll", _this.onAboutScroll, false);
    next(true);
  }
};
</script>
<style scope>
@import "../../../assets/css/all/all.min.css";
@import "../../../assets/css/all/animate.min.css";
@import "../../../assets/css/all/style.css";
@import "../../../assets/css/all/bootstrap.min.css";
.container {
  text-align: left;
  margin-top: 100px;
  margin-bottom: 100px;
}
.title-tip {
  font-size: 26px;
}

.btn-c-978.btn-c-978.btn-c-978.btn-c-978.btn-c-978.btn-c-978{
	background:var(--swatch-var-978);
	color:#FFFFFF!important;
}
.btn-c-978:hover{
	background:#03050D!important;
	color:#FFFFFF!important;
}


.btn-5-style{
	border-radius:25px 25px 25px 25px;
	width:100%;
}

.ios-btn-container{
  position: relative;
}

.ios-btn-container:hover .qr-container{
  display: block;

}

.qr-container{
  display: none;
  position: absolute;
  z-index: 10;
  padding: 10px;
  top: 0;
  left: 50%;
  transform: translateY(-100%) translateX(-50%);
}
.qr-container .container{
  padding: 10px;
  border: 1px solid #c8c8c8;
  border-radius: 4px;
  margin: 0;
  background-color: #fff;
  box-shadow: 2px 2px 2px #aaa;

}
</style>





// WEBPACK FOOTER //
// src/components/zh-cn/xhorseIm/index.vue